import api from './config/api';
interface IUserType {
  id: number;
  admin: boolean;
  name: string | boolean;
  solicitacaoId: number;
  userId: number | boolean;
}

export const postUserSolicitation = (data: IUserType) =>
  api.post(`/solicitacao-user`, {
    admin: data.admin,
    name: data.name,
    solicitacaoId: data.solicitacaoId,
    userId: data.userId,
  });

// buscar todas as solicitacoes
export const getUserSolicitation = (Id: number) => api.get(`/solicitacao-user/${Id}`);

// buscar ultimo id
export const getLastId = () => api.get('/solicitacao-user');
